import React, { Dispatch } from 'react';
import Translator from '../../core/i18n';
import { IFileListPageProps, IFileListPageState } from '../../models/pages/addedActivityFiles';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { Redirect } from 'react-router-dom';
import { ReportService } from '../../api/report-services';

const _logger = Log.create('content.tsx');
const T = Translator.create();
let _common = new Common();
const _reportService = new ReportService();

export class StatsPage extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        _common = new Common();
    }
    public state: any = {
        dashboardId: '',
        name: '',
        reportType: 1,
        link: ''
    };

    public componentDidMount() {
        this.getMetabaseId();
    }

    public componentDidUpdate(prevProps: any, prevState: any) {
        if (prevState.dashboardId != this.state.dashboardId) {
            this.getMetabaseLink(this.state.dashboardId);
        }
    }

    getMetabaseId = async () => {
        const reportData = await _reportService.GetMetabaseIdAsync("");
        var data = await reportData.json();
        if (data.length > 0) {
            data.map((item: any) => {
                this.setState({
                    ...this.state,
                    dashboardId: item.dashboardId,
                    name: item.name,
                    reportType: item.reportType,
                });
            });
        }
    };

    getMetabaseLink = async (metabaseId: string) => {
        const reportData = await _reportService.GetMetabaseLinkAsync(metabaseId);
        var data = await reportData.json();
        if (data.length > 0) {
            this.setState({
                link: data
            });
        }
    };


    public render() {
        return (
            <div className="student-course activities-dashboard" style={{ padding: '10px 50px' }}>
                <div style={{ paddingTop: 0, paddingBottom: 10 }} className="row student-course-header question-filter">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <div>
                                <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_menu_stats')}</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row student-course-header question-filter" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>

                    <div style={{ height: 'Calc(100vh - 132px)', width: '100%' }}>
                        <iframe src={"https://" + this.state.link} height="100%"
                            width="100%"
                        ></iframe>
                    </div>

                </div>
            </div>
        );
    }
}


const CStatsPage = connect(

)(StatsPage);

export default CStatsPage;

